import React, { useContext, useState } from "react";
import AssetGridCard from "./AssetGridCard";
import AssetListCard from "./AssetListCard";
import { useNavigate } from "react-router-dom";
import { Trans } from "react-i18next";
import { ReactSVG } from "react-svg";
import AppContext from "../../../AppContext";

const AssetGroupedList = ({
  assets,
  searchedData,
  c,
  viewModes,
  cardClicked,
  getTimeZoneDateTime,
  t,
  darkMode,
  searchAsset,
  config,
}) => {
  const navigate = useNavigate();
  const [collapsedGroups, setCollapsedGroups] = useState({});

  // if (c.fields?.length === 0) {
  //   return (
  //     <div className="flex gap-2 md:text-xs sm:text-xxs text-xxxs font-medium justify-center text-labels text-center items-center h-fit pb-3">
  //       <Trans i18nKey="home.assetList.emptyTeamConfig">
  //         {t("home.assetList.emptyTeamConfig")}
  //       </Trans>
  //       <img src="EditIcongray.svg" alt="EditIcon" className="h-6" />
  //     </div>
  //   );
  // }

  if (!c || c.collapsed) return null;

  // --- Filtering Assets ---
  const filteredAssets = assets.filter(
    (x) =>
      (!searchedData ||
        searchedData === "" ||
        searchAsset(x, searchedData.toLowerCase())) &&
      c.assetTypes?.map((x) => x.id).includes(x.assetType.id) &&
      c.assetTypes.flatMap((x) => x.assetIds.split(",")).includes(x.id)
  );

  // --- Grouping ---
  const groupedByParent = {};
  const standaloneAssets = [];

  filteredAssets.forEach((asset) => {
    const assetConfig = config.homeConfiguration.find(
      (x) => x.assetType.id === asset.assetType.id
    );
    const modifiedAsset = { ...asset, homeConfig: assetConfig };
    if (asset.parentId && asset.parentId !== "") {
      if (!groupedByParent[asset.parentId]) {
        groupedByParent[asset.parentId] = [];
      }
      groupedByParent[asset.parentId].push(modifiedAsset);
    } else {
      standaloneAssets.push(modifiedAsset);
    }
  });

  const isGrid = viewModes.find((x) => x.current)?.id === "grid";

  const toggleGroup = (parentId) => {
    setCollapsedGroups((prev) => ({
      ...prev,
      [parentId]: !prev[parentId],
    }));
  };

  return (
    <>
      {/* Grouped Assets */}
      {Object.keys(groupedByParent).map((parentId) => {
        const group = groupedByParent[parentId];
        const parentName = group[0]?.parentName;
        const isCollapsed = collapsedGroups[parentId];

        return (
          <div
            key={parentId}
            className="border-l-4 transition-all duration-500 ease-in-out dark:border-slate-400 rounded-tl-xl rounded-bl-xl pl-2"
          >
            <div className=" dark:bg-slate-600 bg-white bg-opacity-50 p-2 rounded">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-2 dark:text-white text-black">
                  <h3 className="font-bold">{parentName}</h3>
                  <span className="text-xs text-white bg-neutral-900 px-2 py-1 rounded">
                    {group.length} Assets
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => navigate(`/details/parent/${parentId}`)}
                    className="dark:text-white text-black dark:border-white border-black border rounded-4xl md:w-16 sm:w-12 w-10 font-medium md:text-xxs sm:text-xxs text-xxxs flex justify-center items-center"
                  >
                    {t("home.assetList.detailsButtonText")}
                  </button>
                  <button
                    type="button"
                    className="text-white font-medium text-xs md:w-5 md:h-5 sm:w-4 sm:h-4 w-3 h-3"
                    onClick={() => toggleGroup(parentId)}
                  >
                    <ReactSVG
                      src="drop-arrow-icon.svg"
                      className={`${
                        !isCollapsed ? "rotate-180" : ""
                      } h-full flex items-center justify-center`}
                      beforeInjection={(svg) => {
                        svg.setAttribute(
                          "style",
                          `stroke: ${darkMode ? "white" : "black"}`
                        );
                      }}
                    />
                  </button>
                </div>
              </div>
            </div>
            {!isCollapsed && (
              <div
                className={`transition-all duration-500 ease-in-out overflow-hidden mt-2 space-y-2`}
              >
                {group.map((v) =>
                  isGrid ? (
                    <AssetGridCard
                      key={v.id}
                      cardClicked={cardClicked}
                      asset={v}
                      getTimeZoneDateTime={getTimeZoneDateTime}
                      t={t}
                      teamConfig={v.homeConfig?.fields}
                      darkMode={darkMode}
                    />
                  ) : (
                    <AssetListCard
                      key={v.id}
                      cardClicked={cardClicked}
                      asset={v}
                      teamConfig={v.homeConfig?.fields}
                    />
                  )
                )}
              </div>
            )}
          </div>
        );
      })}

      {/* Standalone Assets */}
      {standaloneAssets.length > 0 && (
        <div className="standalone-asset-group">
          {/* <div className="standalone-header">
            <h3>Standalone Assets</h3>
            <span>{standaloneAssets.length} Assets</span>
          </div> */}
          <div className="transition-all duration-500 ease-in-out overflow-hidden mt-2 space-y-2">
            {standaloneAssets.map((v) =>
              isGrid ? (
                <AssetGridCard
                  key={v.id}
                  cardClicked={cardClicked}
                  asset={v}
                  getTimeZoneDateTime={getTimeZoneDateTime}
                  t={t}
                  teamConfig={v.homeConfig?.fields}
                  darkMode={darkMode}
                />
              ) : (
                <AssetListCard
                  key={v.id}
                  cardClicked={cardClicked}
                  asset={v}
                  teamConfig={v.homeConfig?.fields}
                />
              )
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default AssetGroupedList;
